"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stakeToStnear = exports.stakeToLinear = exports.getStnearPriceInNear = exports.getLinearPriceInNear = void 0;
const multi_transaction_1 = require("multi-transaction");
async function getLinearPriceInNear(viewer, contractId, blockHeight) {
    return viewer.viewFunction({
        contractId: contractId,
        methodName: 'ft_price',
        blockQuery: blockHeight
            ? {
                blockId: blockHeight,
            }
            : undefined,
    });
}
exports.getLinearPriceInNear = getLinearPriceInNear;
async function getStnearPriceInNear(viewer, contractId, blockHeight) {
    return viewer.viewFunction({
        contractId: contractId,
        methodName: 'get_st_near_price',
        blockQuery: blockHeight
            ? {
                blockId: blockHeight,
            }
            : undefined,
    });
}
exports.getStnearPriceInNear = getStnearPriceInNear;
async function stakeToLinear(sender, contractId, amount) {
    return sender.send(multi_transaction_1.MultiTransaction.batch(contractId).functionCall({
        methodName: 'deposit_and_stake',
        attachedDeposit: amount,
    }));
}
exports.stakeToLinear = stakeToLinear;
async function stakeToStnear(sender, contractId, amount) {
    return sender.send(multi_transaction_1.MultiTransaction.batch(contractId).functionCall({
        methodName: 'deposit_and_stake',
        attachedDeposit: amount,
    }));
}
exports.stakeToStnear = stakeToStnear;
//# sourceMappingURL=contract.js.map